<template>
  <v-container fluid>
    <v-row v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)">
      <v-col cols="12" sm="12" lg="2">
        <v-select v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)" placeholder="Wybierz placówkę..." label="Placówka" :items="dostepnePlacowki" return-object v-model="wybranaPlacowka" item-text="name"></v-select>
      </v-col>
    </v-row>
    <v-layout wrap>
          <v-flex xs12>
            <v-layout column>   
              <v-flex xs12 v-show="!searchResultsVisible">
                  <ejs-schedule height="auto" :startHour="startHour" :endHour="endHour" @dataBinding="createScheduler"
                  :eventSettings='eventSettings' :workHours="workHours" :popupOpen='onPopupOpen' :firstDayOfWeek="firstDayOfWeek" :dataBound="onDataBound"  :eventRendered="oneventRendered" :ownerCollections="therapistsList" :actionBegin="beginAction" @actionComplete="actionComplete"  ref="ScheduleObj" currentView="Day" >
                      <e-views>
                                <e-view option="Day"></e-view>
                                <e-view option="Week"></e-view>              
                                <e-view option="Month"></e-view>
                      </e-views>
                        <e-resources>
                            <e-resource field="therapistID" title="Terapeuci" :dataSource='therapistsList' allowMultiple="true"
                                        name="Terapeuci" textField="therapistName" idField="therapistID" colorField="therapistColor">
                            </e-resource>
                        </e-resources>                       
                  </ejs-schedule>
              </v-flex>           
              <v-flex xs12 v-show="searchResultsVisible">
                <v-data-table              
                      :options.sync="pagination"
                      :items="searchItems"
                      :loading="searchLoading"                      
                      :server-items-length="searchTotalResults"
                      :no-results-text="noResults"
                      :no-data-text="noResults"
                      :footer-props="{
                        itemsPerPageOptions:[20,50,100,200],                        
                      }"                      
                      :headers="headers">
                        <template v-slot:item.startTime="{item}">
                            {{ getFormattedDate(item.startTime) }}
                        </template>
                        <template v-slot:item.endTime="{item}">
                            {{ getFormattedDate(item.endTime) }}
                        </template>
                        <template v-slot:item.status="{item}">
                            {{ getStatusDescription(item.status) }}
                        </template>
                        <template v-slot:item.id="{item}">
                          <v-icon small class="mr-2" @click="showEditPopup(item.id)" title="Edytuj wizyte">fa-user-edit</v-icon>                          
                        </template>         
                </v-data-table>                    
              </v-flex>
            </v-layout>
          </v-flex>
    </v-layout>
    <v-dialog v-model="showVisitEditor" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
        <TherapistVisitEditor v-if="showVisitEditor" :visitData="visitData" @close="closeAddPopup"></TherapistVisitEditor>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { clientService } from "@/services/";
import { visitService } from "@/services/";
import { therapistsService } from "@/services/";

import Vue from 'vue'
import { Day, Week, Month } from "@syncfusion/ej2-vue-schedule";
import * as dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import TherapistVisitEditor from "./TherapistVisitEditor";
import {settingsService} from "@/services";




export default {
  name: "MyCalendar",
  data() {
    return {
      startHour: "06:00",
      endHour: "22:00",
      workHours: {
        highlight: false,
        start: "06:00",
        end: "22:00"
      },
      firstDayOfWeek: 1,
      eventSettings: { dataSource: [] },
      unsubscribeEvent: null,
      visitData: null,
      showVisitEditor: false,
      therapistsList: [],
      localTherapistsList: [],
      fullEventData: [],
      nearVisits: [],
      currentVisits: [],
      pastVisits: [],
      timerNear: 0,
      initialLoad: false,
      timerVisits: 0,
      firstRefresh: false,
      refreshing: false,
      active_tab_visits: 0,
      searchClientId: 0,
      isLoadingClients: false,
      clientsList: [],
      searchTherapistId: 0,
      isLoadingTherapists: false,
      therapists: [],
      clientKeyword: null,
      therapistKeyword: null,
      showSearchDate1: false,
      showSearchDate2: false,
      searchDate1: null,
      searchDate2: null,
      searchOnlyIncomming: false,
      searchResultsVisible: false,
      searchTotalResults: 0,      
      searchLoading: true,
      searchItems: [],
      rowsPerPage: "Ilość wierszy na stronę",
      noResults: "Nie znaleziono danych",
      pagination: {},
      orgPagination: null,
      wybranaPlacowka: null,
      headers: [
        { text: 'Pacjent', sortable: false, align: 'left', value: 'clientName'},
        { text: 'Terapeuta', sortable: false, align: 'left', value: 'therapistName'},
        { text: 'Początek', sortable: false, align: 'left', value: 'startTime'},
        { text: 'Koniec', sortable: false, align: 'left', value: 'endTime'},
        { text: 'Status', sortable: false, align: 'left', value: 'status'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'} 
      ]      
    };
  },
  computed: {
    ...mapState("visits", ["noBlinkVisits"]),
    ...mapState('companySettingsModule',['settings']),
    dostepnePlacowki: function() {
      let placowki = []

      let userDetails = this.$store.state.account.userdetails

      if(this.settings.additionalOutposts && this.settings.additionalOutposts.length > 0)
      {

        this.settings.additionalOutposts.forEach(elem => {
          if(userDetails != null && userDetails.additionalOutposts && (userDetails.additionalOutposts.length == 0 || userDetails.additionalOutposts.indexOf(elem.id) != -1))
            placowki.push(elem)
        })
      }
      return placowki
    },
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    ...mapActions("visits", ["saveNoBlinkVisits"]),
    actionComplete(args) {

      if(args.requestType && args.requestType == 'viewNavigate')
      {
        this.refreshData()
        this.isLayoutChanged = true
      }
      if(args.requestType && args.requestType == 'dateNavigate')
      {
        this.refreshData()
        this.isLayoutChanged = true
      }
    },
    beginAction() {
    },
    onDataBound(args) {
      this.refreshBlinkClasses()
    },
    onPopupOpen(args) {
      this.ShowPopup(args.data);
      args.cancel = true;
    },
    ShowPopup(data) {
      if (!data.Id) return;
      //this.unsubscribeEvent = fn;
      this.visitData = data;
      this.showVisitEditor = true;
    },
    showEditPopup(id) {
      this.ShowPopup({Id: id});
    },
    resetSearch() {
      this.searchClientId = 0
      this.searchTherapistId = 0
      this.searchLoading = false
      this.searchDate1 = null
      this.searchDate2 = null
      this.pagination = {}
      this.searchItems = []
      this.searchOnlyIncomming = false
      this.searchTotalResults = 0
      this.searchResultsVisible = false
      this.pagination = {...this.orgPagination}
      this.active_tab_visits = 0
      this.refreshData()
    },
    getFormattedDate(val) {
      let dj = dayjs(val)
      if (dj != null) {
        return dj.format("DD-MM-YYYY HH:mm")
      } else {
        return val
      }
    },
    getStatusDescription(status) {
      switch (status) {
        case 0:
          return 'Nowa'
        case 1:
          return 'Potwierdzona'
        case 2:
          return 'Anulowana'
        case 3:
          return 'Zakończona'
        default:
          return ''
      }
    },
    handleSearch() {
      /*  if(!this.searchDate1 && !this.searchDate2 && !this.searchOnlyIncomming)
      {
        this.error('Nie wybrano przedziału dat.')
        return
      }*/
      this.getSearchVisits()
    },

    refreshBlinkClasses() {
      let scheduleObj = this.$refs.ScheduleObj;
      let allEvents = scheduleObj.getEvents();
      allEvents.forEach(event => {
        var elems = document.querySelectorAll(
            '[data-id="Appointment_' + event.Id + '"]'
        );
        if (elems != null && elems.length > 0) {
          if (event.pacjent_obecny) elems[0].classList.add("blink_me");
          else elems[0].classList.remove("blink_me");
        }
      });
    },
    refreshData() {
      let dates = this.$refs.ScheduleObj.ej2Instances.getCurrentViewDates()
      let startDate = dates[0]
      let endDate = dates.length > 1 ?  dates[dates.length - 1] : dates[0]
      let user = JSON.parse(localStorage.getItem('user'));
      let data = {
        startDate: dayjs(startDate).format('DD-MM-YYYY'),
        endDate: dayjs(endDate).format('DD-MM-YYYY'),
        przerwy_urlopy: true,
        placowkaId: this.wybranaPlacowka ? this.wybranaPlacowka.id : 0,
        therapistID: user.userId
      }
      visitService.listVisits(data).then(results => {
        let processedData = [];

        if (results != null && results.data.result != null && results.data.result.items != null) {
          results.data.result.items.forEach(item => {
            processedData.push({
              Id: item.id,
              Subject: item.isBlock ? item.blockDescription : item.clientName,
              StartTime: item.startTime,
              EndTime: item.endTime,
              CategoryColor: item.therapistColor,
              Description: '',
              therapistID: item.therapistID,
              State: item.status,
              pacjent_obecny: item.pacjent_obecny,
              isBlock: item.isBlock
            });
          });
          this.handleSuccessData(results.data.result.items)
          this.eventSettings = { dataSource: processedData }
        }
      }).catch(()=> {
        this.error("Błąd pobierania wizyt")
      })
    },
    closeAddPopup() {
      //this.unsubscribeEvent();
      this.visitData = null;
      this.showVisitEditor = false;
      if (this.searchResultsVisible) {
        this.getSearchVisits()
      } else {
        this.refreshData();
        //this.refreshNearVisits();
      }
    },
    addCloseStyles(elem) {
      elem.style.opacity = 0.3;
    },
    addCancelledVisitStyles(elem)
    {
      elem.classList.add("cancelledvisit-icon")
      elem.style.opacity = 0.3;
    },
    clearCloseStyles(id) {
      var elems = document.querySelectorAll(
          '[data-id="Appointment_' + id + '"]'
      );
      if (elems != null && elems.length > 0) {
        //    elems[0].style.display = "block";
        elems[0].style.backgroundImage = ''
      }
    },
    noBlinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = false;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    blinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = true;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    clearBlinkStore() {
      let localArray = [...this.noBlinkVisits];
      let newArray = [];
      localArray.forEach(x => {
        if (this.currentVisits.find(x => x.id == x)) newArray.push(x);
      });
      this.saveNoBlinkVisits(newArray);
    },
    oneventRendered: function (args) {
      if (
          args != null &&
          args.data != null &&
          args.data.therapistID != null &&
          args.data.therapistID > 0
      ) {
        let t = this.localTherapistsList.find(
            x => x.therapistID == args.data.therapistID
        );
        if (t != null && t.checked == false) {
          args.element.style.display = "none";
        } else {
          if (args.data.State == 3) {

            this.addCloseStyles(args.element)
          }
          if(args.data.State == 2)
          {
            this.addCancelledVisitStyles(args.element)
          }
          if(args.data.State == 1)
          {
            this.addConfirmedStyles(args.element)
          }
          if(args.data.State == 4)
          {
            this.addCanceledByUserStyles(args.element)
          }
          if(args.data.State == 5)
          {
            this.addUnknownResponseStyles(args.element)
          }
        }
      }
    },
    addConfirmedStyles(elem)
    {
      elem.classList.add("confirmed-icon")
    },
    addCanceledByUserStyles(elem)
    {
      elem.classList.add("canceledbyuser-icon")
    },
    addUnknownResponseStyles(elem)
    {
      elem.classList.add("wrongsmsanswer-icon")
    },
    handleSuccessData(args) {

      this.localTherapistsList.forEach(item => {
        item.show = false;
      });

      if (args != null) {

        args.forEach(item => {
          let t = this.localTherapistsList.find(
              x => x.therapistID == item.therapistID
          );

          if (!t) {
            //this.therapistsList.push({therapistID: item.therapistID, therapistName: item.therapistName, therapistColor: item.therapistColor, checked: true, show: true})
            this.therapistsList.push({
              therapistID: item.therapistID,
              therapistName: item.therapistName,
              therapistColor: item.therapistColor
            });
            this.localTherapistsList.push({
              therapistID: item.therapistID,
              therapistName: item.therapistName,
              therapistColor: item.therapistColor,
              checked: true,
              show: true
            });
          } else {
            t.therapistName = item.therapistName;
            t.therapistColor = item.therapistColor;
            t.show = true;
          }
        });
        if (!this.firstRefresh) {
          //this.refreshNearVisits();
          this.firstRefresh = true;
        }
      }
    },
    getClientValues(val) {
      this.isLoadingClients = true;
      clientService
          .getAll({query: val, page: 1, limit: 20, sorting: "surname"})
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                let name = item.name + " " + item.surname;
                if (item.pesel != null && item.pesel != "")
                  name = name + "/" + item.pesel;
                this.clientsList.push({
                  id: item.id,
                  name: name,
                  therapist: item.therapistID
                });
              }
            });

            this.isLoadingClients = false;
          })
          .catch(() => {
            this.isLoadingClients = false;
            this.error("Nie można pobrać listy klientów.");
          });
    },
    createScheduler() {
      if(!this.initialLoad)
      {
        this.initialLoad = true
        this.refreshData()
        return
      }
    },
    loadTherapists(val) {
      this.isLoadingTherapists = true;
      therapistsService
          .getAll({query: val, page: 1, limit: 10})
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {
              response.data.result.items.forEach(r => {
                if (!this.therapists.find(x => x.id === r.id))
                  this.therapists.push({
                    id: r.id,
                    name: r.name + " " + r.surname,
                    pay: r.rate
                  });
              });
              this.isLoadingTherapists = false;
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(() => {
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy terapeutów.");
          });
    }
  },
created() {
    this.updateTitle("Mój kalendarz");
  },
  components: {
    TherapistVisitEditor
  },
  provide: {
    schedule: [Day, Week, Month]
  },
  mounted() {
    this.timerVisits = setInterval(this.refreshData.bind(this), 5 * 60 * 1000); //odswiezamy dane co 5 min
    Vue.prototype.$timerMyVisits = this.timerVisits
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrAfter);
    settingsService.GetCompanySettings().then(success=> {
      if(success.data.result)
      {
        let data = success.data.result
        if(data.id > 0)
        {
          if(data.godzina_otwarcia_start)
          {
            this.startHour = dayjs(data.godzina_otwarcia_start).format('HH:mm')
          }
          if(data.godzina_otwarcia_koniec)
          {
            this.endHour = dayjs(data.godzina_otwarcia_koniec).format('HH:mm')
          }
        }
      }
    }).catch(() => {
      this.error('Bład pobierania ustawień firmy')
    })
    if(this.dostepnePlacowki && this.dostepnePlacowki.length > 0)
    {
      this.wybranaPlacowka = this.dostepnePlacowki[0]
    }
  },
  beforeDestroy() {
    clearInterval(this.timerVisits);
  },
  watch: {
    clientKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    wybranaPlacowka() {
      this.refreshData()
    },
    therapistKeyword(val) {
      if (val) {
        this.loadTherapists(val);
      }
    },
    searchOnlyIncomming(val) {
      if(val)
      {
        this.searchDate1 = null
        this.searchDate2 = null
      }
    },
    pagination: {
        handler() {
          if(this.orgPagination == null)
            this.orgPagination = {...this.pagination}
          if(this.searchResultsVisible)
            this.getSearchVisits()
        },
        deep: true
    }    
  }
};
</script>

<style>
.visits .e-schedule table.e-schedule-table td {
  padding: initial;
}
</style>
